






























import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppSwitcher from '@/components/AppSwitcher.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchGeneralAgent from '@/mixins/search-queries/search-ga'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import { IQuoteCarrierInput } from '@/modules/Quote/interfaces/quote-form'
import { IBaseItemInput } from '@/interfaces/form-input'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker,
    AppSwitcher
  }
})
export default class QuoteFormCarrier extends mixins(SearchGeneralAgent, SearchCarrier) {
  @Prop({ type: Object as () => IQuoteCarrierInput }) value!: IQuoteCarrierInput
  @Prop({ type: Boolean }) ifGA!: boolean
  @Prop({ type: Boolean }) disableSwitcher!: boolean

  options = ['GA', 'Direct']

  active = 1

  carrier: IBaseItemInput = {}
  ga: IBaseItemInput = {}

  async mounted () {
    this.ga = this.value.ga
    this.carrier = this.value.carrier
    this.onIfGAChanged(this.ifGA)
  }

  @Watch('ifGA')
  onIfGAChanged (val: boolean) {
    this.active = val ? 0 : 1
  }

  validate () {
    const { ga, carrier, active } = this
    if (active === 0) {
      this.value.ga = ga
      this.value.carrier = carrier
      return (this.$refs.form1 as Vue & { validate: () => boolean }).validate()
    } else {
      this.value.ga = {}
      this.value.carrier = carrier
      return (this.$refs.form2 as Vue & { validate: () => boolean }).validate()
    }
  }
}
